import React, {Component, Fragment,} from 'react'
import {Collapse, Icon, Button, message} from 'antd'
import OrderFileComponent from "../../components/bus/order-file";
import {baseUrl, reqOrderFileFlag} from "../../api";
import 'moment/locale/zh-cn';

const {Panel} = Collapse;

export default class ImportOrderFile extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        const {orderId} = this.props;
        this.hasOrderFileFlag(orderId)
    }

    hasOrderFileFlag = async (orderId) => {
        let result = await reqOrderFileFlag(orderId)
        if (result.code === 200) {
            if (result.data === 'Y') {
                this.setState({hasFile: true})
            }
        } else {
            message.error(result.message)
        }
    }
    download = async () => {
        const url = baseUrl + "/api/v1/p/file/importBoxFileDownload?orderId=" + this.props.orderId;
        window.open(url, "_blank");
    };
    getChildrenMsg = (objType, length) => {
        this.setState({[objType]: length})
    };
    genExtra = (objType) => {
        if (this.state[objType] > 0) {
            return <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" onClick={event => {
                event.stopPropagation();
            }}/>
        } else {
            return <Icon type="edit" onClick={event => {
                event.stopPropagation();
            }}/>
        }
    };

    render() {
        const customPanelStyle = {
            background: '#fff',
        };
        const {orderId} = this.props;
        const {hasFile} = this.state;
        return (<div className='info-content'>
                <Button type='primary' onClick={this.download} disabled={!hasFile}>一键下载</Button>
                <Collapse bordered={false} defaultActiveKey={['1', '2', '3', '4', '5', '6', '7', '8']}>
                    <Panel header="提单照片" key="1" style={customPanelStyle}
                           extra={this.genExtra("import_order_lading_bill")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg}
                                            objectType={"import_order_lading_bill"}/>
                    </Panel>
                    <Panel header="箱单照片" key="2" style={customPanelStyle}
                           extra={this.genExtra("import_order_box_note")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"import_order_box_note"}/>
                    </Panel>
                    <Panel header="发票照片" key="3" style={customPanelStyle} extra={this.genExtra("import_order_invoice")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"import_order_invoice"}/>
                    </Panel>
                    <Panel header="合同照片" key="4" style={customPanelStyle}
                           extra={this.genExtra("import_order_contract")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"import_order_contract"}/>
                    </Panel>
                    <Panel header="提箱/卸货" key="5" style={customPanelStyle} extra={this.genExtra("import_box")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg} objectType={"import_box"}/>
                    </Panel>
                    <Panel header="倒装" key="6" style={customPanelStyle}
                           extra={this.genExtra("import_box_loading_license")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg}
                                            objectType={"import_box_loading_license"}/>
                    </Panel>
                    <Panel header="发车" key="7" style={customPanelStyle}
                           extra={this.genExtra("import_box_departure_license")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg}
                                            objectType={"import_box_departure_license"}/>
                    </Panel>
                    <Panel header="抵达仓库" key="8" style={customPanelStyle}
                           extra={this.genExtra("import_box_arrive_license")}>
                        <OrderFileComponent orderId={orderId} {...this.props} noQrcode={true}
                                            getChildrenMsg={this.getChildrenMsg}
                                            objectType={"import_box_arrive_license"}/>
                    </Panel>
                </Collapse>
            </div>
        )
    }
}